import React from 'react'
import './NFTMintingDevelopment.css'
import AutoPlayminting from './NftMintingslider'
import { Link } from "react-router-dom";

const NFTMintingDevelopment = () => {
  return (
    <div>
      <main id="nft_marketplace_main">
        <section className="nft_marketplace_banner">
          <div className="container">
            <div className="row align-items-center justify-content-center banner_img_col">
              <div className="col-lg-6 col-12">
                <div className="banner_sec">
                  <h1 className="ourservice-titles-new"><span className="cus_title">NFT Minting </span> <br /> DEVELOPMENT COMPANY</h1>
                  <p className="contents">Leading NFT platform development company MetaBlock is getting ready to launch an NFT platform that will enable anyone to produce and sell NFTs without the need for technical coding expertise. You can make billions of dollars in revenue with our NFT minting system.
                  </p>
                  <Link to="/contact-us">
                    <div className="banner_btn_sec">
                      <a data-toggle="modal" data-target="#popup_form_modal" className="btn banner_btn" target="_blank">Request A Quote</a>
                    </div>
                  </Link>
                </div>
              </div>
              <div className='col-lg-6 col-12 nft-development-container-right-div' />
              <div className="col-lg-6 col-12 nft-development-container-right">
                <img src="./images/nft-minting-development.webp" alt="Clone List" title="Clone List" className="img-fluid lazyload text-center"
                  style={{ width: '500px', height: '300px', borderRadius: '5px', backgroundPosition: 'center', backgroundSize: 'cover' }} />
              </div >            </div>
          </div>
        </section>
        <section className="nft_marketplace_clone_sec">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-12">
                <div className="row align-items-center">
                  <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                    <div>
                      <h2 className="grident-color-sub-title title"><span className=" grident-color-sub-title">NFT</span> <br /> <span className="cus_title2 grident-color-sub-title">Marketplace</span><br /><span className="cus_title3 grident-color-sub-title">Clones</span></h2>
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-12 col-sm-12 col-12 nft_marketplace_col_styling">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="clones_box">
                          <div className="contents" data-toggle="modal" data-target="#popup_form_modal">
                            <img style={{ height: "7vh" }} src="./images/Opensea-Clone.webp" alt="Opensea Clone" title="Opensea Clone" />
                            <div className="grident-color-sub-title sub_title">Opensea <br /> Clone</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="clones_box">
                          <div className="contents" data-toggle="modal" data-target="#popup_form_modal">
                            <img style={{ height: "7vh" }} src="./images/Rarible-Clone.webp" alt="Rarible Clone" title="Rarible Clone" />
                            <div className="grident-color-sub-title sub_title">Rarible <br /> Clone</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="clones_box">
                          <div className="contents" data-toggle="modal" data-target="#popup_form_modal">
                            <img style={{ height: "7vh" }} src="./images/NBA-Clone.webp" alt="NBA Top Shot Clone" title="NBA Top Shot Clone" />
                            <div className="grident-color-sub-title sub_title">NBA Top Shot <br /> Clone</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="clones_box">
                          <div className="contents" data-toggle="modal" data-target="#popup_form_modal">
                            <img style={{ height: "7vh" }} src="./images/SuperRare-Clone.webp" alt="SuperRare Clone" title="SuperRare Clone" />
                            <div className="grident-color-sub-title sub_title">SuperRare <br /> Clone</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="clones_box">
                          <div className="contents" data-toggle="modal" data-target="#popup_form_modal">
                            <img style={{ height: "7vh" }} src="./images/Crytopunks-Clone.webp" alt="Crytopunks Clone" title="Crytopunks Clone" />
                            <div className="grident-color-sub-title sub_title">Crytopunks <br /> Clone</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-12">
                        <div className="clones_box">
                          <div className="contents" data-toggle="modal" data-target="#popup_form_modal">
                            <img style={{ height: "7vh" }} src="./images/Foundation-Clone.webp" alt="Foundation Clone" title="Foundation Clone" />
                            <div className="grident-color-sub-title sub_title">Foundation <br /> Clone</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clones_btn_sec">
                      <a className="btn clones_btn" data-toggle="modal" data-target="#popup_form_modal">Get A Free Demo</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="nft_marketplace_clone_dev_sec">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-titles-new">NFT Marketplace Development - <br /> A SureFire Way For Converting NFT To Funds</h2>
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-5 col-12 order-2 order-lg-1">
                <div className="img_sec ">
                  <img src="./images/NFT-Game-Development-Company-img.webp " alt="NFT Game Development Company" title="NFT Game Development Company" loading="eager" style={{ borderRadius: "10px" }} />
                </div>
              </div>
              <div className="col-lg-7 col-12 order-1 order-lg-2">
                <div className>
                  <p className="contents">NFT Marketplace Development is an ultimate doorway for entrepreneurs to launch a decentralized NFT Marketplace Platform over the Various Blockchain like Ethereum, Solana, Polygon, Tron and Stellar networks
                    to trade NFT Tokens. Our White Label NFT Marketplace Platform Development has special features and functionalities where users can buy and sell their desired digital items easily and securely.</p>
                  <p className="contents">We Metablock help you to launch your own NFT marketplace platform and attract the growing community of NFT users and to enhance your NFT users trading experiences. We also offer End-End NFT Marketplace Development
                    services from front end to back end smart contract development, dapp development that comes with feature-rich, decentralized, and facilitate tokenization of all kinds of digital assets, including artwork,
                    gaming cards, and software lice. Metablock is one of the most reputed and best NFT marketplace development company noted by delivering unbeatable blockchain services and solutions in the Competitive market
                    world.</p>
                  <div className="nft_game_dev_about_btn_sec">
                    <a href="https://wa.me/9828284421" className="btn nft_game_dev_about_btn desktop" target="_blank"><i className="fab fa-whatsapp" />&nbsp;WhatsApp</a>

                    <a href="https://web.telegram.org/k/#@metablocktechnologies" className="btn nft_game_dev_about_btn1" target="_blank"><i className="fab fa-telegram" />&nbsp;Telegram</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="nft_marketplace_services">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-titles-new">End-End NFT Marketplace Development Services</h2>
            <div className="row justify-content-center scroll_row">
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/operator.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT Marketplace Consultation Services</h3>
                  </div>
                  <p className="sub_contents">Our Proactive NFT consultants help you about tech aspects of NFT marketplace platform development by delivering informative consultation and business strategies. Our well skilled NFT Influencers, investors and stake holders
                    gives an idea to build your NFT Platform and Increase your scale.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/website.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT Marketplace Platform Development</h3>
                  </div>
                  <p className="sub_contents">Starting own NFT Marketplace platform is a smarter way to earn profits by the process of buy and sell unique NFT digital assets. NFT Marketplace Development is an one-stop destination for showcasing and trading NFTs easily.
                    We cover NFT digital Marketplace for art, collectibles, GameFi, metaverse.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/contract.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT Smart Contract Development</h3>
                  </div>
                  <p className="sub_contents">NFT smart contract is a self executing program runs on blockchain that automatically enforces specific actions once the conditions are met. NFT smart contract development to manage minting, owning, transfer and tracking NFTs.
                    NFT smart contract based agreements with any functions you would prefer will be there.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/online-order.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT Marketplace App Development</h3>
                  </div>
                  <p className="sub_contents">NFT Marketplace App Development keeps you to track and monitor the NFT's for Browse, create, buy, sell, and auction NFTs. We develop your a highly User Intent NFT Marketplace App that makes your process in single touch. Our
                    team of 100+ NFT Developers helps you to enhance trading experience.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/nft.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">Metaverse NFT Marketplace Development</h3>
                  </div>
                  <p className="sub_contents">Metaverse has been enhancing the usability and worth of NFTs. It is possible by developing a futuristic Metaverse nft marketplace development that support digital collectibles, in-game assets, avatars, virtual land and digital
                    characters which enables quick and seamless crypto transactions.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/game.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT Marketplace Game Development</h3>
                  </div>
                  <p className="sub_contents">Creating a NFT Marketplace Game Platform also now possible with our leading blokchain development company, Metablock. We have well equipped AR/VR team with Unity 3D Game Development Service like Unity Animation, Unity modeling which
                    builds you a modernized NFT Game Platform.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/offer.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT-Based ICO Development</h3>
                  </div>
                  <p className="sub_contents">Leverage our NFT-Based ICO Development services as we offer a platform for entrepreneurs and business enthusiasts to raise funds by selling or exchanging NFT tokens using legal tender or cryptocurrencies. With our deep knowledge
                    and expertise in Blockchain technology, we can help you transform your idea into a reality by launching an NFT-based Initial Coin Offering (ICO).</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'60px'} src="./images/system.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">NFT Lending Platform</h3>
                  </div>
                  <p className="sub_contents">We provide cutting-edge NFT lending platform services with a user-friendly interface, making it simple and interactive for users to manage their loans. With a focus on secure product development, we leverage our expertise in
                    Smart Contracts to ensure the safety and reliability of the lending process.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="service_box">
                  <div className="head_sec">
                    <img width={'50px'} src="./images/marketplace.webp" alt="Animate Icon" title="Animate Icon" loading="eager" className="img-fluid lazyload" />
                    <h3 className="grident-color-sub-title sub_title">E-Commerce NFT Marketplace</h3>
                  </div>
                  <p className="sub_contents">Tap into the powerful synergy of eCommerce and blockchain-based NFT marketplaces and unlock a multitude of opportunities that can drive transformative outcomes for your business. Seamlessly merge the world of online commerce
                    with the potential of non-fungible tokens, empowering your brand with new avenues for growth and success with our avant e-commerce NFT Marketplace services.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="nft_marketplace_clone_whitelabel">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-7 col-12">
                <div className>
                  <h2 className="grident-color-sub-title ourservice-titles-new">Whitelabel NFT Marketplace Development</h2>
                  <p className="contents">Metablock, being a renowned NFT development company offers the robust White-Label NFT Marketplace Development Solution with all advanced features and functionalities to acquire a powerful NFT marketplace platform. We provide pocket-pleasant
                    costs for a custom-designed and quicker carrier with an energetic crew of technical experts, rendering 24*7 support. Our featured script has a secured back-give-up with customizations withinside the logo, templates, and
                    subject matters together with your favored UI/UX designs, saving hours of deployment and money.</p>
                  <div className="nft_marketplace_btn_sec">
                    <a data-toggle="modal" data-target="#popup_form_modal" className="btn nft_marketplace_btn" target="_blank">Get A Free Demo</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-12">
                <div className="img_sec ">
                  <img src="./images/Whitelabel-NFT-Marketplace-Development.webp " alt="NFT Game Development Company" title="NFT Game Development Company" loading="eager" style={{ borderRadius: "10px" }} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="nft_marketplace_usecase">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-titles-new">NFT Use Causes</h2>
            <div className="nft-marketplace-usecase slider">
              <AutoPlayminting />
            </div>
          </div>
        </section>
        <section className="nft_marketplace_roadmap">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-titles-new">Road Map To Create NFT Marketplace</h2>
            <div className="osc_timeline">
              <div className="row justify-content-center align-items-center row_align timeline_vertical">
                <div className="col-lg-12">
                  <div>
                    <div className="row timeline_counter_before">
                      <div className="col-md-6">
                        <div className="timeline_card timeline_margin_right ">
                          <h3 className="grident-color-sub-title sub_title">Understanding Your Use Case</h3>
                          <p className="sub_contents">Before developing the NFT Marketplace, it is essential to identify blockchain and target audience.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                        </div>
                      </div>
                    </div>
                    <div className="row timeline_counter_before">
                      <div className="col-md-6">
                      </div>
                      <div className="col-md-6">
                        <div>
                          <div className="timeline_card timeline_margin_left ">
                            <h3 className="grident-color-sub-title sub_title">UI/UX design</h3>
                            <p className="sub_contents">UI/UX design is of great importance as it catches users interest and makes them come back for more.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row timeline_counter_before">
                      <div className="col-md-6">
                        <div className="timeline_card timeline_margin_right ">
                          <h3 className="grident-color-sub-title sub_title">Smart Contract Development</h3>
                          <p className="sub_contents">The smart contract that makes the NFT Marketplace work efficiently is being developed in this hase.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                        </div>
                      </div>
                    </div>
                    <div className="row timeline_counter_before">
                      <div className="col-md-6">
                      </div>
                      <div className="col-md-6">
                        <div className="timeline_card timeline_margin_left ">
                          <h3 className="grident-color-sub-title sub_title">Integrating Pivotal Features</h3>
                          <p className="sub_contents">The development of a single NFT marketplace is not enough. It is vital to integrate it with climatic characteristics in order to attract potential users.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row timeline_counter_before">
                      <div className="col-md-6">
                        <div className="timeline_card timeline_margin_right ">
                          <h3 className="grident-color-sub-title sub_title">Testing</h3>
                          <p className="sub_contents">Once the relevant features have been added to your NFT Marketplace, it is subject to stringent testing procedures.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                      </div>
                    </div>
                    <div className="row timeline_counter_before">
                      <div className="col-md-6">
                      </div>
                      <div className="col-md-6">
                        <div className="timeline_card timeline_margin_left ">
                          <h3 className="grident-color-sub-title sub_title">Going Live</h3>
                          <p className="sub_contents">We launch the product into the global NFT area as soon as all the use instances had been successfully assessed and the proposed upgrades had been incorporated for your newly developed NFT marketplace.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="nft_marketplace_features">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-titles-new">Features of NFT Marketplace Development</h2>
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box bor_fst ">
                  <img width={'50px'} src="./images/digital-wallet.webp" alt="Digital Wallet" title="Digital Wallet" />
                  <h3 className="grident-color-sub-title sub_title">Digital Wallet</h3>
                  <p className="sub_contents">It's miles vital to combine virtual wallets into NFT Marketplaces. We permit customers to keep, send, and manipulate cryptocurrencies and NFTs with the aid of integrating digital wallets.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box ">
                  <img width={'50px'} src="./images/rate.webp" alt="Rating" title="Rating" />
                  <h3 className="grident-color-sub-title sub_title">Rating</h3>
                  <p className="sub_contents">The method is to charge digital collectibles. This lets in customers to view the digital merchandise they're looking to shop for and conjointly lets them decide on the most exceptional virtual collectibles inside the digital
                    market.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box bor_last ">
                  <img width={'50px'} src="./images/store.webp" alt="Storefront" title="Storefront" />
                  <h3 className="grident-color-sub-title sub_title">Storefront</h3>
                  <p className="sub_contents">The Storefront highlight is fundamental in any NFT Marketplace. This includes giving all points of interest approximately the stock that the client is acquiring. This highlight moreover gives data approximately the proprietors,
                    offers, and esteem history.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box bor_fst ">
                  <img width={'50px'} src="./images/list.webp" alt="Listing" title="Listing" />
                  <h3 className="grident-color-sub-title sub_title">Listing</h3>
                  <p className="sub_contents">It ought to be speedy and simple to compile and yield computerized collectibles. We have made a collection supervisor that will keep track of all the things and the collections to guarantee a smooth workflow.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box ">
                  <img width={'50px'} src="./images/filter.webp" alt="Filter Option" title="Filter Option" />
                  <h3 className="grident-color-sub-title sub_title">Filter Option</h3>
                  <p className="sub_contents">Our NFT commercial center channels make it less demanding for clients to explore the site easily, particularly when there are endless collectibles.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box bor_last ">
                  <img width={'50px'} src="./images/auctions.webp" alt="Auctions & Bids" title="Auctions & Bids" />
                  <h3 className="grident-color-sub-title sub_title">Auctions &amp; Bids</h3>
                  <p className="sub_contents">Barters are respected as one of the foremost vital highlights within the NFT commercial center.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box bor_bottom ">
                  <img width={'50px'} src="./images/search.webp" alt="Token Search" title="Token Search" />
                  <h3 className="grident-color-sub-title sub_title">Token Search</h3>
                  <p className="sub_contents">Clients ought to be able to get to data around anything thing at any time and in a consistent way.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="features_box bor_bottom ">
                  <img width={'50px'} src="./images/auction-listing.webp" alt="English Auction Listing" title="English Auction Listing" />
                  <h3 className="grident-color-sub-title sub_title">English Auction Listing</h3>
                  <p className="sub_contents">The English sell-off posting permits clients to offer at a moo fetched and get progress gradually. This sort of offering permits clients to settle for the most elevated offered.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="nft_marketplace_blockchain">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-titles-new">NFT Marketplace Development on Various Blockchains</h2>
            <div className="row justify-content-center">
              <div className="col-lg-2 col-md-6 cus_col">
                <div className="tech_stact_card ">

                  <img width={'80px'} src="./images/ethereum.webp " alt="Various Blockchains" title="Various Blockchains" />
                  <p className="grident-color-sub-title sub_title">Ethereum</p>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 cus_col">
                <div className="tech_stact_card ">

                  <img width={'80px'} src="./images/solana.webp " alt="Various Blockchains" title="Various Blockchains" />
                  <p className="grident-color-sub-title sub_title">Solana</p>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 cus_col">
                <div className="tech_stact_card ">

                  <img width={'80px'} src='./images/Binance.webp' alt="Various Blockchains" title="Various Blockchains" />
                  <p className="grident-color-sub-title sub_title">Binance Smart Chain</p>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 cus_col">
                <div className="tech_stact_card ">

                  <img width={'80px'} src='./images/polygon.webp' alt="Various Blockchains" title="Various Blockchains" />
                  <p className="grident-color-sub-title sub_title">Polygon</p>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 cus_col">
                <div className="tech_stact_card ">

                  <img width={'80px'} src='./images/tron.webp' alt="Various Blockchains" title="Various Blockchains" />
                  <p className="grident-color-sub-title sub_title">TRON</p>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 cus_col">
                <div className="tech_stact_card ">

                  <img width={'80px'} src='./images/polkadot.webp' alt="Various Blockchains" title="Various Blockchains"
                  />
                  <p className="grident-color-sub-title sub_title">Polkadot</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="token_dev_techstack">
          <div className="container">
            <h2 className="grident-color-sub-title ourservice-title">Our Technology Stack</h2>
            <div className="row tech ">
              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/physics.webp" className="w-100 h-40" alt="React" />
                <h5 className="grident-color-sub-title">React</h5>
              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/python.webp" alt="Python" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Python</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3" >
                <img src="./images/mysql.webp" alt="MySQL" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">MySQL</h5>
              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/java-script.webp" alt="Java Srcipt" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Java Srcipt</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/SQL-Lite.webp" alt="SQL Lite" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">SQL Lite</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/html.webp" alt="HTML" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">HTML</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/android.webp" alt="Android" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Android</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/mongo-db-icon.webp" alt="Mongo DB" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Mongo DB</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/app-store.webp" alt="App Store" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">App Store</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/atom.webp" alt="Atom" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Atom</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/laravel.webp" alt="Laravel" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Laravel</h5>

              </div>

              <div className="col-md-2 mt-5 d-flex justify-center align-center flex-column gap-3">
                <img src="./images/python.webp" alt="Python" className="w-100 h-40" />
                <h5 className="grident-color-sub-title">Python</h5>

              </div>
            </div>
          </div>
        </section>
        <section className="nft_marketplace_whychoose">
          <div className="container">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-5 col-12 order-2 order-lg-1">
                <div className="img_sec ">
                  <img src="./images/nftmarketplace02.webp" alt="Why Choose Metablock For NFT Marketplace Development?" title="Why Choose Metablock For NFT Marketplace Development?" loading="eager" style={{ borderRadius: "10px" }} />
                </div>
              </div>
              <div className="col-lg-7 col-12 order-1 order-lg-2">
                <div className>
                  <h2 className="grident-color-sub-title ourservice-titles-new">Why Choose Metablock For NFT Marketplace Development?</h2>
                  <p className="contents">Metablock is a leading white label NFT Marketplace development company, provides top-rated NFT Marketplace platform development services for various fields like artworks, videos, collectibles, etc. We build the NFT marketplace over
                    various blockchain platforms like BinanceSmartChain, Ethereum, Tron, Matic, etc according to your business demands. We design and develop NFT marketplace platforms with exclusive features and functionalities that help to
                    grab users on your NFT marketplace</p>
                  <Link to="/contact-us">
                    <div className="nft_marketplace_btn_sec">
                      <a data-toggle="modal" data-target="#popup_form_modal" className="btn nft_marketplace_btn" target="_blank">Talk To Our Expert</a>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row justify-content-center scroll_row">
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">14 Years of Experience</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Agile Development Process</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Dedicated Development Team</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Globally Recognized</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">100% NFT White Label Solutions</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">End-to-End NFT Marketplace Solutions</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Enterprise-grade Solutions</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">State-of-the-Art Technologies</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Long-term Business Support</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Global Quality Standards</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Best in Class Project Development</div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="whychoose_box">Support &amp; Maintenance Services</div>
              </div>
            </div>
          </div>
        </section>
      </main>





    </div>
  )
}

export default NFTMintingDevelopment
